import { lazy } from "@remhealth/ui";

export type { AppProps } from "./app/app";
export type { AboutBellsProps } from "./settings/about/aboutBells";

export * from "./app/browser";
export * from "./app/routes";
export * from "./config";
export * from "./embed";
export * from "./theme";

export const App = lazy(() => import("./app/app"));
export const Diagnostics = lazy(() => import("./app/diagnostics"));
export const TokenDisplay = lazy(() => import("./app/profile/tokenDisplay"));
export const QualityAssurance = lazy(() => import("./audit/qualityAssurance"));
export const EmbeddedSettingsPage = lazy(() => import("./settings/embedded/embeddedSettingsPage"));

export { Text } from "./text";
